import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter, useHistory } from "react-router-dom";
import ReactPlayer from "react-player";

import BookmarkBorderIcon from "@material-ui/icons/BookmarkBorder";
import LinkIcon from "@material-ui/icons/Link";
import ChatBubbleOutlineIcon from "@material-ui/icons/ChatBubbleOutline";
import ThumbUpAltIcon from "@material-ui/icons/ThumbUpAlt";
import MapIcon from "@material-ui/icons/Map";
import Grid from "@material-ui/core/Grid";
import Link from "@material-ui/core/Link";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Divider from "@material-ui/core/Divider";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Avatar from "@material-ui/core/Avatar";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import {
  withStyles,
  makeStyles,
  useTheme,
  withTheme,
} from "@material-ui/core/styles";

//import "../../assets/css/customstyles.css";

import Services from "../../api/api";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    maxWidth: "36ch",
    backgroundColor: theme.palette.background.paper,
  },
  inline: {
    display: "inline",
  },
}));

class Champion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: 0,
      list: [],
      orignalList: [],
      championObj: {},
    };
    this.handleClick = this.handleClick.bind(this);
    this.getChampionDetail = this.getChampionDetail.bind(this);
  }

  componentDidMount() {
    this.getChampionDetail(this.props.selectedComponentObj.new.id);
  }

  getChampionDetail(contentid) {
    console.log("getChampionDetail>>", contentid);
    // let params = {
    //   communityId: this.props.communityuid,
    //   contentId: contentid,
    //   languageId: this.props.langId,
    // };
    let params = {
      communityId: this.props.communityuid,
      contentId: contentid,
      languageId: this.props.langId,
      roleId: JSON.parse(localStorage.getItem("obj")).roleId,
      userId: JSON.parse(localStorage.getItem("obj")).userId,
    };

    Services.getRoleWiseContent(params).then((res) => {
      try{
        if (res.data.status == 200) {
          if (res.data.data.childs) {
            this.setState({
              championObj: res.data.data.childs[5],
            });
          }
        }
      }catch(err){
        console.log("err::", err)
      }
    });
  }
  handleClick(championObj, url) {
    console.log("KnowledgeList handleClick>>", url);
    this.props.history.push({
      pathname: "/layout/championdetail",
      state: { championObj: championObj, url: url },
    });
  }

  render() {
    console.log('champions>>>', this.state.championObj)
    if(Object.keys(this.state.championObj).length == 0) {
      return null
    }
    
    return (
      <Grid container spacing={3} className="gridcontainer">
        {this.state.championObj &&
          this.state.championObj.contentList[0].infographics &&
          this.state.championObj.contentList[0].infographics.map((url) => {
            return (
              <>
                <Grid
                  item
                  xs={5}
                  className="zero championvidoholder"
                  onClick={() => this.handleClick(this.state.championObj, url)}
                >
                  <ReactPlayer
                    url={url}
                    width={130}
                    height={100}
                    light={true}
                    playIcon={<div></div>}
                    style={{ marginTop: "0px" }}
                  />
                </Grid>
                <Grid
                  item
                  xs={7}
                  className=" tbchamprightdiv"
                  onClick={() => this.handleClick(this.state.championObj, url)}
                >
                  <p className="zero tbchamptitle">
                    {this.state.championObj.contentName}
                  </p>
                  <p className="zero tbchampdesc">
                    Shares experience on TB drug side effect…
                  </p>
                  {/* <div className="infolinkcontainer text-left">
                    <Link onClick="">
                      <BookmarkBorderIcon />
                    </Link>
                    <Link onClick="">
                      <LinkIcon />
                    </Link>
                    <Link onClick="">
                      <ChatBubbleOutlineIcon />
                    </Link>
                    <Link onClick="">
                      <ThumbUpAltIcon />
                    </Link>
                  </div> */}
                </Grid>
              </>
            );
          })}
      </Grid>
    );
  }
}

const mapStateToProps = (state) => {
  let { storeState } = state;
  return {
    communityuid: storeState.communityId,
    langId: storeState.langId,
    selectedComponentObj: storeState.componentObj
  };
};

const ThemeChampion = withTheme(Champion);
const FinalThemeChampion = withStyles(useStyles)(ThemeChampion);
const routeChampion = withRouter(FinalThemeChampion);
export default connect(mapStateToProps, {})(routeChampion);
